import axios from 'axios'
import config from '../config/app'

const engagementAPI = {
  getUsersEngagement (additionalFields, pageNo = null, statusFilter = '', searchKeyword = '', sortBy = '') {
    let str = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
    if (pageNo !== null && pageNo !== undefined) {
      str = str + 'page_no=' + pageNo + '&'
    }
    if (statusFilter !== null && statusFilter !== undefined) {
      str = str + 'status=' + statusFilter + '&'
    }
    if (searchKeyword !== null && searchKeyword !== undefined) {
      str = str + 'keyword=' + searchKeyword + '&'
    }
    if (sortBy !== null && sortBy !== undefined) {
      str = str + 'sort_by=' + sortBy
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/engagement/user?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAdditionalEngagement (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/additional', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        console.log('in j222s')
        console.log(error)
        reject(error)
      })
    })
  },
  issueAdditionalEngagement (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/additional-issue', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEngagementDetails (key, additionalFields) {
    let str = (additionalFields !== null && additionalFields !== undefined) ? 'key=' + key + '&additional=' + additionalFields.join(',') + '&' : ''
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/engagement/user?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEngagementByKey (key, additionalFields) {
    let str = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/v2/engagement/' + key + '?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  get (additionalFields) {
    let str = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/campaign?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateSettings (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteEngagement (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/delete', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createEngagement (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/create', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  TokenLessBalanceEmail (engagementId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/token-email-notification/' + engagementId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeProject (projectId) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/campaign/project/' + projectId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateEnagamentCopySegment (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/copy/update-segment', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkBlockIp (engagementId, clientIP) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/v2/engagement/check-block-ip/' + engagementId + '/' + clientIP).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getIpAddress (engagementId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/v2/engagement/get-ip/' + engagementId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadQRCode (engagementKey) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/engagement/download-QR-code/' + engagementKey).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkDuplicateEngamentemail (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/v2/engagement/check-duplicate-email', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHistory (engagementId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/engagement/get-history/' + engagementId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  attachTag (event) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/engagement/attach-tag/' + event).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default engagementAPI



// WEBPACK FOOTER //
// ./src/api/engagement.js